// extracted by mini-css-extract-plugin
export default {"card":"ClothingIcon_card__haNwr","space":"ClothingIcon_space__O77I8","label":"ClothingIcon_label__uUsv9"};